import management from './management'
import configurations from './configurations'
import adTypes from './ad-types'
import adDebugger from './ad-debugger'

export default [
  ...management,
  ...configurations,
  ...adTypes,
  ...adDebugger,
]
